import { __assign } from "tslib";
import { black, white, pinkA400, blue100 } from "./colors";
var colors = {
  primary: '#042F86',
  primaryHover: '#117AAA',
  darkCyan: '#117AAA',
  darkCyanHover: '#30AEDF',
  cyan: '#30AEDF',
  cyanHover: '#117AAA',
  green: '#14882C',
  softBlack: '#333333',
  lightCyan: '#EDFAFF',
  lightGrey: '#F7F7F7',
  selected: '#105BFB',
  error: '#FC5350',
  yellow: '#F3D22F',
  lightGreen: '#56AC69',
  grey: '#818589'
};
var Theme = {
  header: '#FFF',
  animation: {
    scale: 1
  },
  colors: colors,
  table: {
    wrapper: {
      flexDirection: "row"
    },
    row: {
      flexDirection: "row",
      overflow: "hidden",
      height: 28
    },
    cols: {
      flexDirection: "row"
    },
    cell: {
      borderTopWidth: 1,
      borderTopColor: colors.grey,
      width: '90%'
    },
    text: {
      backgroundColor: "transparent"
    }
  },
  underline: function (props) {
    var _a, _b;
    return {
      borderBottomColor: (_a = colors[props.color]) !== null && _a !== void 0 ? _a : 'black',
      borderBottomWidth: (_b = props.width) !== null && _b !== void 0 ? _b : 1
    };
  },
  alert: {
    inline: {
      backgroundColor: colors.lightCyan,
      padding: 20,
      borderRadius: 10,
      borderColor: colors.darkCyan,
      borderWidth: 2,
      shadowColor: '#171717',
      shadowOffset: {
        width: -2,
        height: 4
      },
      shadowOpacity: 0.2,
      shadowRadius: 3,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around'
    },
    success: {
      backgroundColor: colors.lightGreen,
      padding: 20,
      borderRadius: 10,
      borderColor: colors.green,
      borderWidth: 2,
      shadowColor: '#171717',
      shadowOffset: {
        width: -2,
        height: 4
      },
      shadowOpacity: 0.2,
      shadowRadius: 3,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around'
    },
    warning: {
      backgroundColor: colors.yellow,
      padding: 20,
      borderRadius: 10,
      borderColor: colors.lightGrey,
      borderWidth: 2,
      shadowColor: '#171717',
      shadowOffset: {
        width: -2,
        height: 4
      },
      shadowOpacity: 0.2,
      shadowRadius: 3,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around'
    },
    error: {
      backgroundColor: colors.error,
      padding: 20,
      borderRadius: 10,
      borderColor: colors.lightGrey,
      borderWidth: 2,
      shadowColor: '#171717',
      shadowOffset: {
        width: -2,
        height: 4
      },
      shadowOpacity: 0.2,
      shadowRadius: 3,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around'
    }
  },
  text: {
    title: {
      fontSize: 40,
      fontFamliy: "Montserrat",
      fontWieght: 500
    },
    offerCardTitle: {
      fontSize: 25,
      fontFamliy: "Montserrat",
      fontWieght: 700,
      color: colors.blue
    },
    cardTitle: {
      fontSize: 22,
      fontFamliy: "Montserrat",
      fontWieght: 500,
      color: '#1B1B1B'
    },
    totalAmount: {
      fontSize: 22,
      fontFamliy: "Montserrat",
      fontWieght: 700,
      color: colors.darkCyan
    },
    pageTitle: {
      fontSize: 21,
      fontFamliy: "Montserrat",
      fontWieght: 700,
      color: colors.darkCyan,
      textTransform: 'uppercase'
    },
    notificationCardTitle: {
      fontSize: 16,
      fontFamliy: "Montserrat",
      fontWieght: 600,
      color: colors.blue
    },
    formLabel: {
      fontSize: 14,
      fontFamliy: "Halenoir Compact Text",
      fontWieght: 500,
      color: '#5C5C5C'
    },
    formInput: {
      fontSize: 14,
      fontFamliy: "Halenoir Compact Text",
      fontWieght: 500,
      color: '#1B1B1B'
    },
    helperText: {
      fontSize: 14,
      fontFamliy: "Halenoir Compact Text",
      fontWieght: 500,
      color: '#8B8B8B'
    },
    offerCardSubject: {
      fontSize: 14,
      fontFamliy: "Halenoir Compact Text",
      fontWieght: 600,
      color: '#5C5C5C',
      textTransform: 'uppercase'
    },
    hyperlink: {
      fontSize: 14,
      fontFamliy: "Halenoir Compact Text",
      fontWieght: 600,
      color: colors.darkCyan
    },
    button: {
      fontSize: 13,
      fontFamliy: "Montserrat",
      fontWieght: 500,
      textTransform: 'uppercase',
      lineSpacing: 30,
      color: 'white'
    },
    subtitle: {
      marginVertical: 0,
      fontSize: 13,
      fontFamliy: "Halenoir Compact Text",
      fontWieght: 600,
      color: '#5C5C5C'
    }
  },
  button: {
    spinner: {
      width: 16,
      color: 'white'
    },
    icon: {
      width: 16,
      color: 'white',
      marginRight: 15
    },
    default: function (props) {
      return __assign(__assign(__assign(__assign({
        backgroundColor: !props.outlined ? colors[props.color] : 'white',
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: props.size == "small" ? 15 : 30,
        paddingRight: props.size == "small" ? 15 : 30,
        borderRadius: 10
      }, !props.outlined ? {} : {
        borderColor: colors[props.color],
        borderWidth: 2
      }), {
        cursor: 'pointer'
      }), props.size == "large" ? {} : {
        width: 'fit-content'
      }), {
        content: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }
      });
    },
    hover: function (props) {
      return __assign(__assign({
        backgroundColor: colors["".concat(props.color, "Hover")],
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: props.size == "small" ? 15 : 30,
        paddingRight: props.size == "small" ? 15 : 30,
        borderRadius: 10,
        cursor: 'pointer'
      }, props.size == "large" ? {} : {
        width: 'fit-content'
      }), {
        content: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }
      });
    },
    focused: function (props) {
      return {
        backgroundColor: props.contained ? colors[props.color] : 'white',
        paddingTop: 15,
        paddingBottom: 15,
        paddingLeft: props.size == "small" ? 15 : 30,
        paddingRight: props.size == "small" ? 15 : 30,
        borderRadius: 10,
        borderColor: colors.darkCyan,
        borderWidth: 2,
        cursor: 'pointer',
        content: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center'
        }
      };
    },
    pressed: {},
    loading: {},
    disabled: {}
  }
};
export default Theme;